import { Controller } from "@hotwired/stimulus"
import "jquery"
import "select2"

export default class extends Controller {
  connect() {
    this.initializeSelect2()
    this.calculateTotalCost()
    this.initializeCocoonCallbacks()
  }

  initializeCocoonCallbacks() {
    $(this.element).on('cocoon:after-insert', (e, insertedItem) => {
      $(insertedItem).find('.select2-ajax').select2({
        theme: 'bootstrap-5',
        ajax: {
          url: `/api/v1/companies/${this.element.dataset.companyId}/finish_products`,
          dataType: 'json',
          delay: 250,
          data: function(params) {
            return {
              search: params.term
            }
          },
          processResults: function(data) {
            return {
              results: data.map(item => ({
                id: item.id,
                text: item.full_name
              }))
            }
          },
          cache: true
        },
        minimumInputLength: 2,
        placeholder: $(this).data('placeholder'),
        allowClear: true,
        selectionCssClass: 'select2--small',
        dropdownCssClass: 'select2--small',
        width: '100%'
      })
      // Update total cost when overhead cost is added (similar to bolt production)
      this.updateTotalCost()
    })
    
    $(this.element).on('cocoon:after-remove', () => {
      // Update total cost when overhead cost is removed (similar to bolt production)
      this.updateTotalCost()
    })
  }

  initializeSelect2() {
    const companyId = this.element.dataset.companyId

    $('.select2-ajax').select2({
      theme: 'bootstrap-5',
      ajax: {
        url: `/api/v1/companies/${companyId}/finish_products`,
        dataType: 'json',
        delay: 250,
        data: function(params) {
          return {
            search: params.term
          }
        },
        processResults: function(data) {
          return {
            results: data.map(item => ({
              id: item.id,
              text: item.full_name
            }))
          }
        },
        cache: true
      },
      minimumInputLength: 2,
      placeholder: $(this).data('placeholder'),
      allowClear: true,
      selectionCssClass: 'select2--small',
      dropdownCssClass: 'select2--small',
      width: '100%'
    })
  }

  calculateTotalCost() {
    const quantityField = this.element.querySelector('#unfinish_product_quantity')
    const costPerProductField = this.element.querySelector('#unfinish_product_cost_per_product')
    const totalCostField = this.element.querySelector('#unfinish_product_total_cost')

    if (quantityField && costPerProductField && totalCostField) {
      this.updateTotalCost()
      
      // Listen to quantity and cost per product changes
      quantityField.addEventListener('input', () => this.updateTotalCost())
      costPerProductField.addEventListener('input', () => this.updateTotalCost())
      
      // Use event delegation to catch overhead cost price changes
      // This works for both existing and dynamically added fields (via Cocoon)
      this.element.addEventListener('input', (e) => {
        if (e.target && e.target.hasAttribute('data-overhead-cost-price')) {
          this.overheadCostChanged()
        }
      })
      
      this.element.addEventListener('change', (e) => {
        if (e.target && e.target.hasAttribute('data-overhead-cost-price')) {
          this.overheadCostChanged()
        }
      })
    }
  }

  // Called when overhead cost price changes (similar to rawMaterialTotalChanged in bolt production)
  overheadCostChanged() {
    setTimeout(() => {
      this.updateTotalCost()
    }, 100) // Small delay to ensure the value has been updated
  }

  updateTotalCost() {
    const quantityField = this.element.querySelector('#unfinish_product_quantity')
    const costPerProductField = this.element.querySelector('#unfinish_product_cost_per_product')
    const totalCostField = this.element.querySelector('#unfinish_product_total_cost')

    if (quantityField && costPerProductField && totalCostField) {
      const quantity = parseFloat(quantityField.value) || 0
      const costPerProduct = parseFloat(costPerProductField.value) || 0
      
      // Check if this is a bolt product (overhead costs are already included in boltProductionCost)
      const isBoltProduct = this.element.dataset.isBoltProduct === 'true'
      
      // If quantity is 0, use cost_per_product value (for bolt products where cost_per_product = boltProductionCost)
      // This prevents overhead costs from overriding the initial total_cost
      if (quantity === 0) {
        totalCostField.value = costPerProduct > 0 ? costPerProduct.toFixed(2) : "0.00"
        return
      }
      
      const baseTotal = quantity * costPerProduct
      
      // For bolt products, don't add overhead costs as they're already included in the boltProductionCost
      let overheadTotal = 0
      if (!isBoltProduct) {
        // Sum all overhead cost prices (similar to how bolt production sums raw material totals)
        const overheadCostPrices = this.element.querySelectorAll('input[data-overhead-cost-price]')
        overheadCostPrices.forEach((priceField) => {
          // Skip fields that are marked for destruction
          const nestedFields = priceField.closest('.nested-fields')
          if (nestedFields) {
            const destroyField = nestedFields.querySelector('input[name*="[_destroy]"]')
            if (destroyField && destroyField.value === '1') {
              return
            }
          }
          const price = parseFloat(priceField.value) || 0
          overheadTotal += price
        })
      }
      
      const finalTotal = baseTotal + overheadTotal
      totalCostField.value = finalTotal.toFixed(2)
    }
  }
}
